// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { GoogleAuthProvider, getAuth } from "firebase/auth";
import { setLogLevel } from "firebase/firestore";
import { getStorage } from "firebase/storage";


export const provider = new GoogleAuthProvider();

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCQzqeMQuFSlGPd49oESRG6u5Jakvfmoo4",
    authDomain: "djeke-app.firebaseapp.com",
    projectId: "djeke-app",
    storageBucket: "djeke-app.appspot.com",
    messagingSenderId: "769691820224",
    appId: "1:769691820224:web:5a04fbf0edf9b1019b0d25"
  };
  
  // Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app); // ✅ add this

setLogLevel("debug");

